import React from 'react';
import {Route} from 'react-router';
import Header from './header';
import Footer from './footer';

export default ({component: Component, ...rest}) => (
  <Route
    {...rest}
    render={matchProps => (
      <div className="kt-grid kt-grid--hor kt-grid--root">
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
          style={{backgroundColor: '#FFF'}}
        >
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
            <Header />
            <div className="kt-container kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-grid--stretch">
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                  <Component {...matchProps} />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    )}
  />
);
